import { TableRow, TableCell, Box, SxProps, Theme } from '@mui/material';
import StandardRow, { BaseTableRowProps } from './StandardRow';

export const ExpandableRow = (props: BaseTableRowProps) => {
  const {
    headers,
    hasLeadingColumn,
    lastColumnElement,
    isExpanded = false,
    expandedContent,
    rowStyles,
    borderOverride,
    isNested = false,
    onExpand,
    ...restProps
  } = props;
  const elementType =
    typeof lastColumnElement === 'function' ? lastColumnElement(props.row) : lastColumnElement;

  const totalCols = headers.length + (elementType !== 'none' ? 1 : 0) + (hasLeadingColumn ? 1 : 0);
  const boxRowStyles: SxProps<Theme> | undefined =
    !isNested && expandedContent && isExpanded && borderOverride
      ? ({ ...borderOverride, ...rowStyles } as SxProps<Theme>)
      : (rowStyles ?? undefined);

  return (
    <>
      <TableRow>
        <TableCell colSpan={totalCols} sx={{ padding: '0 !important' }}>
          <Box
            sx={{
              padding: '0 !important',
              borderRadius: !isNested && !isExpanded ? '8px' : !isNested ? '8px 8px 0 0' : '0px',
              ...boxRowStyles,
            }}>
            <Box
              sx={{
                padding: '0 !important',
                display: 'table',
                width: '100%',
                tableLayout: 'fixed',
              }}>
              <StandardRow
                headers={headers}
                hasLeadingColumn={hasLeadingColumn}
                lastColumnElement={lastColumnElement}
                expandedContent={expandedContent}
                isExpanded={isExpanded}
                isNested={isNested}
                onExpand={onExpand}
                {...restProps}
              />
            </Box>
          </Box>
        </TableCell>
      </TableRow>

      {isExpanded && expandedContent && (
        <TableRow>
          <TableCell colSpan={totalCols} sx={{ padding: '0 !important' }}>
            <Box
              sx={{
                borderRadius: !isNested ? '0 0 8px 8px' : '0px',
                ...rowStyles,
              }}>
              {expandedContent}
            </Box>
          </TableCell>
        </TableRow>
      )}

      {!isNested && (
        <TableRow>
          <TableCell
            colSpan={totalCols}
            sx={{
              padding: 0,
              height: theme => theme.spacing(2),
            }}
          />
        </TableRow>
      )}
    </>
  );
};

export default ExpandableRow;
